import React from "react";
import { Grid, RadioGroup } from "@mui/material";
import Button from "../../../../../library/custom/button/Button";
import { generateSwInspectionNPDES } from "../../../../../utils/swInspectionHelper";
import DatePicker from "../../../../../library/custom/datePicker/DatePicker";
import { parseDate } from "../../../../../utils/helper";
import { InputField } from "../../../../../library/custom/textBox/InputField";
import { NumberField } from "../../../../../library/custom/numberField/numberField";
import TImePicker from "../../../../../library/custom/timePicker/TImePicker";
import RadioButton from "../../../../../library/custom/radioButton/RadioButton";

const SouthCarolina = (props) => {
    const addMoreSwInspectionNPDES = () => {
        const newObjects = generateSwInspectionNPDES(5);
        props?.setSwInspectionNPDES((prevState) => [
            ...prevState,
            ...newObjects,
        ]);
    };
    const swInspectionNPDESHandler = (
        index,
        date,
        time,
        duration,
        precipitationAmount,
        discharge,
        locationOfDischarge
    ) => {
        props?.setSwInspectionNPDES((prevState) => {
            const updatedData = [...prevState];

            // Process duration: ONLY convert empty strings to null, preserve all other values
            let processedDuration = duration;
            if (duration === "" || duration === null) {
                processedDuration = null;
            }

            // Process precipitationAmount: ONLY convert empty strings to null, preserve all other values
            let processedPrecipitation = precipitationAmount;
            if (precipitationAmount === "" || precipitationAmount === null) {
                processedPrecipitation = null;
            }

            updatedData[index] = {
                ...updatedData[index],
                date: date
                    ? parseDate(date, "MM-dd-yyyy")
                    : "",
                time: time,
                duration: processedDuration,
                precipitationAmount: processedPrecipitation,
                discharge: discharge,
                locationOfDischarge: locationOfDischarge,
            };

            return updatedData;
        });
    };
    return (
        <>
            <Grid item md={12} className="northCarolinaOverride">
                <div className="commonTableBoxNorth">
                    <div className="commonTableBoxNorthTitle">
                        South Carolina NPDES Permit Additional Information
                    </div>
                    <div className="tableWrapper">
                        <table>
                            <tr className="tableHead">
                                <th>Date </th>
                                <th>Time</th>
                                <th>Duration(days)</th>
                                <th>Precipitation Amount</th>
                                <th>Discharge</th>
                                <th>Location of Discharges during inspection</th>
                            </tr>

                            {props?.swInspectionNPDES?.map(
                                (inspectionNPDES, index) => {
                                    return (
                                        <tr className="tableBody" key={inspectionNPDES?.id}>
                                            <td>
                                                <DatePicker
                                                    onChangeHandler={(e) =>
                                                        swInspectionNPDESHandler(
                                                            index,
                                                            e,
                                                            inspectionNPDES?.time,
                                                            inspectionNPDES?.duration,
                                                            inspectionNPDES?.precipitationAmount,
                                                            inspectionNPDES?.discharge,
                                                            inspectionNPDES?.locationOfDischarge,
                                                            inspectionNPDES?.id
                                                        )
                                                    }
                                                    value={
                                                        parseDate(
                                                            inspectionNPDES?.date,
                                                            "MM-dd-yyyy"
                                                        ) ?? ""
                                                    }
                                                    maxDateEnable={false}
                                                />
                                            </td>
                                            <td>
                                                <TImePicker
                                                    value={inspectionNPDES?.time}
                                                    onChangeTimeHandler={(e) =>
                                                        swInspectionNPDESHandler(
                                                            index,
                                                            inspectionNPDES?.date,
                                                            e?.target?.value,
                                                            inspectionNPDES?.duration,
                                                            inspectionNPDES?.precipitationAmount,
                                                            inspectionNPDES?.discharge,
                                                            inspectionNPDES?.locationOfDischarge,
                                                            inspectionNPDES?.id
                                                        )}
                                                />
                                            </td>
                                            <td>
                                                <InputField
                                                    isRequired={false}
                                                    type="text"
                                                    step="1"
                                                    min="0"                                                    
                                                    placeholder={"Enter Here..."}
                                                    value={inspectionNPDES?.duration}
                                                    onChange={(e) => {
                                                        // Only allow numeric values
                                                        const numericValue = e.target.value;
                                                        if (numericValue === '' || /^\d*\.?\d*$/.test(numericValue)) {
                                                            swInspectionNPDESHandler(
                                                                index,
                                                                inspectionNPDES?.date,
                                                                inspectionNPDES?.time,
                                                                numericValue,
                                                                inspectionNPDES?.precipitationAmount,
                                                                inspectionNPDES?.discharge,
                                                                inspectionNPDES?.locationOfDischarge,
                                                                inspectionNPDES?.id
                                                            );
                                                        }
                                                    }}
                                                />

                                            </td>
                                            <td>
                                                <InputField
                                                    isRequired={false}
                                                    type="text"
                                                    step="0.01"
                                                    min="0"
                                                    placeholder={"Enter Here..."}
                                                    value={inspectionNPDES?.precipitationAmount}
                                                    onChange={(e) => {
                                                        // Only allow numeric values
                                                        const numericValue = e.target.value;
                                                        if (numericValue === '' || /^\d*\.?\d*$/.test(numericValue)) {
                                                            swInspectionNPDESHandler(
                                                                index,
                                                                inspectionNPDES?.date,
                                                                inspectionNPDES?.time,
                                                                inspectionNPDES?.duration,
                                                                numericValue,
                                                                inspectionNPDES?.discharge,
                                                                inspectionNPDES?.locationOfDischarge,
                                                                inspectionNPDES?.id
                                                            );
                                                        }
                                                    }}
                                                />

                                            </td>
                                            <td className="southCarolinaRadioTable">
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    className="radioGroup"
                                                >
                                                    <RadioButton
                                                        checked={inspectionNPDES?.discharge == "1"}
                                                        value="1"
                                                        label="Yes"
                                                        onChange={(e) =>
                                                            swInspectionNPDESHandler(
                                                                index,
                                                                inspectionNPDES?.date,
                                                                inspectionNPDES?.time,
                                                                inspectionNPDES?.duration,
                                                                inspectionNPDES?.precipitationAmount,
                                                                e?.target?.value,
                                                                inspectionNPDES?.locationOfDischarge,
                                                                inspectionNPDES?.id
                                                            )
                                                        }
                                                    ></RadioButton>
                                                    <RadioButton
                                                        checked={inspectionNPDES?.discharge == "2"}
                                                        value="2"
                                                        label="No"
                                                        onChange={(e) =>
                                                            swInspectionNPDESHandler(
                                                                index,
                                                                inspectionNPDES?.date,
                                                                inspectionNPDES?.time,
                                                                inspectionNPDES?.duration,
                                                                inspectionNPDES?.precipitationAmount,
                                                                e?.target?.value,
                                                                inspectionNPDES?.locationOfDischarge,
                                                                inspectionNPDES?.id
                                                            )
                                                        }
                                                    ></RadioButton>
                                                </RadioGroup>
                                            </td>
                                            <td>
                                                <InputField
                                                    isRequired={false}
                                                    type="text"
                                                    placeholder={"Enter Here..."}
                                                    value={inspectionNPDES?.locationOfDischarge || ""}
                                                    onChange={(e) =>
                                                        swInspectionNPDESHandler(
                                                            index,
                                                            inspectionNPDES?.date,
                                                            inspectionNPDES?.time,
                                                            inspectionNPDES?.duration,
                                                            inspectionNPDES?.precipitationAmount,
                                                            inspectionNPDES?.discharge,
                                                            e?.target?.value,
                                                            inspectionNPDES?.id
                                                        )
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    );
                                }
                            )}

                        </table>
                    </div>
                    <Grid container mt={2}>
                        <Button
                            varientTextGreen={true}
                            label={"Add More Rows"}
                            onClick={addMoreSwInspectionNPDES}
                        />
                    </Grid>
                </div>
            </Grid>
        </>
    )
}

export default SouthCarolina;